import './App.css';
import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
// import Login from './Screens/Login';
// import Signup from './Screens/Signup';
// import Homepage from './Screens/Homepage';
// import Payment from './Screens/Payment';
import { getToken } from './Store/StaffReducer/staffSlice';
import { useDispatch } from 'react-redux';
// import Static from './Screens/Static';
import TabsulLandingPage from './Screens/TabsulLandingPage';
import TabsulQuiz from './Screens/TabsulQuiz';
import TabsulLearn from './Screens/TabsulLearn';
import TabsulQsType from './Screens/TabsulQsType';

function App() {

  const dispatch = useDispatch()

  // const tokenFinder = () => {
  //   if (JSON.parse(localStorage.getItem("userInfo"))) {
  //     return JSON.parse(localStorage.getItem("userInfo"));
  //   } else {
  //     return "";
  //   }
  // };

  // const data = tokenFinder()

  useEffect(()=>{
    dispatch(getToken(JSON.parse(localStorage.getItem("userInfo"))))
  },[dispatch])

  return (
    <React.Fragment>
      <Routes>
        {/* {data === '' &&<Route path='*' element={<Signup/>}/>}
        {data !== '' && !data.profile && <Route path='*' element={<Login/>}/>}
        {data !== '' && data.profile && !data.premium && <Route path='*' element={<Payment/>}/>}
        {data !== '' && data.profile && data.premium && <Route path='' element={<Homepage/>}/>} */}
        <Route path='/' element={<TabsulLandingPage/>}/>
        <Route path="/mocktest/:id" element={<TabsulQsType />} />
        <Route path="/mocktest/:id/:qs" element={<TabsulQuiz/>} />
        <Route path="/learn/:id" element={<TabsulLearn  />} />
        
      </Routes>
    </React.Fragment>
  );
}

export default App;